<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Create New {{ 'Organisation' | ize }}
    </h4>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('exit')"
    ></button>
  </div>

  @if (form) {
    <form [formGroup]="form" (validSubmit)="onSubmit()" class="form-section">
      <div class="modal-body pb-0">
        <h5 class="card-title mb-2">{{ 'Organisation' | ize }} Details</h5>
        <app-form-control margin="small" [columnLayout]="true" size="medium">
          <app-form-label [required]="true">Name</app-form-label>
          <input
            type="text"
            [ngClass]="{
              'is-invalid':
                form.controls.name.touched && form.controls.name.invalid,
            }"
            class="form-control"
            formControlName="name"
          />
          @if (form.controls.name.hasError('required')) {
            <div class="invalid-feedback">Name is required</div>
          }
        </app-form-control>

        <app-form-control [columnLayout]="true" size="medium" margin="small">
          <app-form-label> Description </app-form-label>
          <input
            type="text"
            [ngClass]="{
              'is-invalid':
                form.controls.description.touched &&
                form.controls.description.invalid,
            }"
            class="form-control"
            formControlName="description"
          />
        </app-form-control>

        <app-form-control [columnLayout]="true" size="small" margin="small">
          <app-form-label [required]="true">Country</app-form-label>
          <select
            class="form-select"
            formControlName="countryId"
            [class.is-invalid]="
              form.controls.countryId.touched && form.controls.countryId.invalid
            "
          >
            <option value="">Select&hellip;</option>

            @for (country of countries; track country) {
              <option [ngValue]="country.id">
                {{ country.name }}
              </option>
            }
          </select>
        </app-form-control>

        <hr />

        <div formGroupName="billingContactDetails">
          <h5 class="card-title mb-2">Billing Contact Details</h5>
          <div class="checkbox-enhanced mb-2">
            <input
              type="checkbox"
              id="useOwnDetails"
              (change)="checkUseOwnDetails($event)"
              [checked]="useOwnDetails"
            />
            <label for="useOwnDetails"> Use my own details </label>
          </div>
          @if (!useOwnDetails) {
            <app-form-control
              [columnLayout]="true"
              size="medium"
              margin="small"
            >
              <app-form-label [required]="true">Name</app-form-label>
              <input
                type="text"
                [ngClass]="{
                  'is-invalid':
                    form.controls.billingContactDetails.controls.name.touched &&
                    form.controls.billingContactDetails.controls.name.invalid,
                }"
                class="form-control"
                formControlName="name"
              />
              @if (
                form.controls.billingContactDetails.controls.name.hasError(
                  'required'
                )
              ) {
                <div class="invalid-feedback">Billing Name is required</div>
              }
            </app-form-control>

            <app-form-control
              [columnLayout]="true"
              size="medium"
              margin="small"
            >
              <app-form-label [required]="true">Email</app-form-label>
              <input
                type="text"
                [ngClass]="{
                  'is-invalid':
                    form.controls.billingContactDetails.controls.email
                      .touched &&
                    form.controls.billingContactDetails.controls.email.invalid,
                }"
                class="form-control"
                formControlName="email"
              />
              @if (
                form.controls.billingContactDetails.controls.email.hasError(
                  'required'
                )
              ) {
                <div class="invalid-feedback">Billing Email is required</div>
              }
            </app-form-control>

            <app-form-control [columnLayout]="true" size="small" margin="small">
              <app-form-label> Phone Number </app-form-label>
              <input
                type="text"
                [ngClass]="{
                  'is-invalid':
                    form.controls.billingContactDetails.controls.phoneNumber
                      .touched &&
                    form.controls.billingContactDetails.controls.phoneNumber
                      .invalid,
                }"
                class="form-control"
                formControlName="phoneNumber"
              />
            </app-form-control>
          }
        </div>

        <hr />

        <app-alert type="warning">
          By clicking Save, you will be creating a new subscription which will
          be billed separately.
        </app-alert>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline"
          [disabled]="form.disabled"
          (click)="modal.dismiss()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary ms-2"
          [disabled]="form.disabled"
        >
          <i-lucide name="save"></i-lucide>
          Save
        </button>
      </div>
    </form>
  }
</ng-template>
